// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2_iZr","buttons":"SendReceipts_buttons__1Q6R5","email":"SendReceipts_email__2q8FO","bookApptTitle":"SendReceipts_bookApptTitle__196aD"};